/**
 * TestSurveyPages - Test survey component with page-based structure
 * For testing surveys before publishing
 */

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Alert,
  Button
} from '@mui/material';
import { BugReport as TestIcon } from '@mui/icons-material';
import TakeSurveyPages from '../respondent/TakeSurveyPages';

export default function TestSurveyPages() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [testMode] = useState(true); // Flag to indicate test mode
  
  return (
    <Box>
      {/* Test mode banner */}
      <Container maxWidth="md" sx={{ mt: 4, mb: 2 }}>
        <Alert 
          severity="warning" 
          icon={<TestIcon />}
          sx={{ 
            mb: 2,
            bgcolor: 'warning.lighter',
            borderLeft: '4px solid',
            borderColor: 'warning.main'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Box sx={{ fontWeight: 600, mb: 0.5 }}>
                🧪 Режим тестирования
              </Box>
              <Box sx={{ fontSize: '0.875rem' }}>
                Это предварительный просмотр опроса. Ответы не будут сохранены в базе данных.
              </Box>
            </Box>
            <Button 
              onClick={() => navigate('/client/dashboard')}
              variant="outlined"
              size="small"
              sx={{ ml: 2, flexShrink: 0 }}
            >
              Вернуться к дашборду
            </Button>
          </Box>
        </Alert>
      </Container>
      
      {/* Render survey using TakeSurveyPages component */}
      <TakeSurveyPages testMode={testMode} surveyId={id} />
    </Box>
  );
}
